@if (layout === 'empty') {
  <empty-layout></empty-layout>
}

@if (layout !== 'empty') {
  <vertical-layout></vertical-layout>
}
